<template>
  <FontFillText
    :text="promoText"
    styleGroup="Promo Text"
    :getFont="promoTextStyle.get"
    :setFont="promoTextStyle.set"
    :minSize="minSize"
    :alignment="alignment"
    :justifyContent="justifyContent"
    :lineHeight="lineHeight"
  ></FontFillText>
</template>

<script lang="ts">
import { Brand } from "@fresh8/types/src";

import { defineComponent, PropType } from "vue";
import FontFillText from "./FontFillText.vue";

export default defineComponent({
  name: "PromoFittedText",
  components: { FontFillText },
  props: {
    promoText: { type: String, required: true },
    alignment: {
      type: String as PropType<"flex-end" | "flex-start" | "center">,
      default: "center"
    },
    justifyContent: {
      type: String as PropType<"flex-end" | "flex-start" | "center">,
      default: "center"
    },
    lineHeight: {
      type: Number,
      default: 1.2
    },
    minSize: {
      type: Number,
      default: 10
    }
  },
  setup() {
    return {
      promoTextStyle: {
        get(brand: Brand | undefined) {
          return brand?.adTemplate.market.promoTextFont;
        },
        set(brand: Brand, value: string) {
          brand.adTemplate.market.promoTextFont = value;
        }
      }
    };
  }
});
</script>
